export const en = {
    'product-description-cannot-be-more-than-max': {
        one: 'The product description must not exceed {maxLength} characters',
        some: 'The product description must not exceed {maxLength} characters',
        many: 'The product description must not exceed {maxLength} characters',
        none: 'The product description must not exceed {maxLength} characters'
    },
    'product-name-cannot-be-more-than-max': {
        one: 'The product name must not exceed {maxLength} characters',
        some: 'The product name must not exceed {maxLength} characters',
        many: 'The product name must not exceed {maxLength} characters',
        none: 'The product name must not exceed {maxLength} characters'
    },
    'product-with-this-name-already-exists': 'A product with this name already exists',
    'unknown-error-text': 'Unable to update product'
};
